import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';

const DevicesPage = () => {
  return (
    <Container maxWidth="lg">
      <Box mt={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          Devices
        </Typography>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="body1">
            Device management coming soon...
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default DevicesPage; 